module.exports = __webpack_public_path__ + "img/login_bg.ad5e4631.png";